import React, {Component, createRef, Fragment} from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { format } from "rut.js";
import NationalitiesSelect from "../../territory/nationalities/Select";
import TerritoryNestedSelects from "../../territory/nested/Selects";
import EducationLevelsSelect from "../../education/levels/Select";
import DriversLicensesSelect from "./DriversLicensesSelect";
import { savePersonaInformation } from "./Axios";
import FieldWrapper from "../../commons/FieldWrapper";
import RelationshipContactSelect from "./RelationshipContactSelect";
import ProfileCustomQuestions from "./ProfileCustomQuestions"
import Notifications from "../../commons/Notifications";

class PersonalInformationForm extends Component {
  constructor(props) {
    super(props);

    const { current_user } = this.props;

    const customQuestions = props.current_user.profile_custom_questions || [];
    const initialCustomAnswers = {};
    customQuestions.forEach(q => {
      if (q.answer !== undefined && q.answer !== null) {
        initialCustomAnswers[q.id] = q.answer;
      }
    });

    this.notificationsRef = createRef();

    this.state = {
      personalInformation: {
        id: { value: current_user.personal_information.id },
        avatar: { value: current_user.avatar, file: null, errors: [] },
        selfDescription: { value: current_user.personal_information.self_description, errors: [] },
        firstName: { value: current_user.personal_information.first_name, errors: [] },
        middleName: { value: current_user.personal_information.middle_name || "", errors: [] },
        lastName: { value: current_user.personal_information.last_name, errors: [] },
        socialName: { value: current_user.personal_information.social_name, errors: [] },
        documentId: { value: current_user.identification_document_number, errors: [] },
        birthdate: { value: current_user.personal_information.birthdate, errors: [] },
        gender: { value: current_user.personal_information.gender, errors: [] },
        identify_lgtbi: { value: current_user.personal_information.identify_lgtbi, errors: [] },
        is_otd: { value: current_user.personal_information.is_otd, errors: [] },
        otherGender: { value: current_user.personal_information.other_gender, errors: [] },
        email: { value: current_user.email, errors: [] },
        lastEmail: { value: current_user.personal_information.last_email, errors: [] },
        cellphone: { value: current_user.personal_information.cellphone, errors: [] },
        landline: { value: current_user.personal_information.landline, errors: [] },
        address: { value: current_user.personal_information.address, errors: [] },
        country: {
          value: current_user.personal_information.country.value,
          label: current_user.personal_information.country.label,
          errors: []
        },
        region: {
          value: current_user.personal_information.region.value,
          label: current_user.personal_information.region.label,
          errors: []
        },
        commune: {
          value: current_user.personal_information.commune.value,
          label: current_user.personal_information.commune.label,
          errors: []
        },
        nationality: {
          value: current_user.personal_information.nationality.value,
          label: current_user.personal_information.nationality.label,
          errors: []
        },
        educationLevel: {
          value: current_user.personal_information.education_level.value,
          label: current_user.personal_information.education_level.label,
          errors: []
        },
        driversLicense: {
          value: current_user.personal_information.drivers_license.value,
          label: current_user.personal_information.drivers_license.label,
          errors: []
        }
      },
      disabilityInformation: {
        id: { value: current_user.disability_information.id },
        hasDisability: { value: current_user.disability_information.has_disability, errors: [] },
        hasDisabilityCredential: {
          value: current_user.disability_information.has_disability_credential,
          errors: []
        },
        hasInvalidityPension: {
          value: current_user.disability_information.has_invalidity_pension,
          errors: []
        }
      },
      contactInformation: {
        id: { value: current_user.contact_information.id },
        relationship: {
          value: current_user.contact_information.relationship.value,
          label: current_user.contact_information.relationship.label,
          errors: []
        },
        contactName: { value: current_user.contact_information.contact_name, errors: [] },
        contactPhoneNumber: {
          value: current_user.contact_information.contact_phone_number,
          errors: []
        },
        contactEmail: { value: current_user.contact_information.contact_email, errors: [] }
      },
      profileCustomQuestions: customQuestions,
      customAnswers: initialCustomAnswers,
      wasSubmitted: false,
    };
  }

  showNotification = (title, message, type) => {
    if (this.notificationsRef.current) {
      this.notificationsRef.current.addNotifications(title, message, type);
    }
  };

  handleCustomAnswerChange = (questionId, value) => {
    this.setState(prev => ({
      customAnswers: { ...prev.customAnswers, [questionId]: value }
    }));
  };

  handleChangePersonalInformation = (e, fieldName = null) => {
    const { personalInformation } = this.state;
    if (fieldName) {
      personalInformation[fieldName]["value"] = e.value;
      personalInformation[fieldName]["label"] = e.label;
      personalInformation[fieldName]["errors"] = [];
    } else if (e.target.id === "documentId") {
      personalInformation[e.target.name]["value"] = format(e.target.value);
      personalInformation[e.target.name]["errors"] = [];
    } else {
      personalInformation[e.target.name]["value"] = e.target.value;
      personalInformation[e.target.name]["errors"] = [];
    }
    this.setState({ personalInformation });
  };

  handleChangeDisabilityInformation = (e, fieldName = null) => {
    const { disabilityInformation } = this.state;
    if (fieldName) {
      disabilityInformation[fieldName]["value"] = e.value;
      disabilityInformation[fieldName]["label"] = e.label;
      disabilityInformation[fieldName]["errors"] = [];
    } else {
      disabilityInformation[e.target.name]["value"] = e.target.value;
      disabilityInformation[e.target.name]["errors"] = [];
    }
    this.setState({ disabilityInformation });
  };

  handleChangeContactInformation = (e, fieldName = null) => {
    const { contactInformation } = this.state;
    if (fieldName) {
      contactInformation[fieldName]["value"] = e.value;
      contactInformation[fieldName]["label"] = e.label;
      contactInformation[fieldName]["errors"] = [];
    } else {
      contactInformation[e.target.name]["value"] = e.target.value;
      contactInformation[e.target.name]["errors"] = [];
    }
    this.setState({ contactInformation });
  };

  handleClenDisabilityInformation = () => {
    const { disabilityInformation } = this.state;
    disabilityInformation.hasDisabilityCredential.value = "";
    disabilityInformation.hasInvalidityPension.value = "";
    this.setState({ disabilityInformation });
  };



  handleChangeAvatar = e => {
    const { personalInformation } = this.state;
    personalInformation["avatar"]["file"] = event.target.files[0];
    personalInformation["avatar"]["value"] = URL.createObjectURL(event.target.files[0]);
    personalInformation["avatar"]["errors"] = [];
    this.setState({ personalInformation });
  };

  serializeData = () => {
    let formData = new FormData();
    const { personalInformation, disabilityInformation, contactInformation } = this.state;
    formData.append("user[identification_document_number]", personalInformation.documentId.value);
    formData.append("user[email]", personalInformation.email.value);
    if (personalInformation.avatar.file) {
      formData.append("user[avatar]", personalInformation.avatar.file);
    }
    if (personalInformation.id.value) {
      formData.append("user[personal_information_attributes][id]", personalInformation.id.value);
    };
    formData.append(
      "user[personal_information_attributes][self_description]",
      personalInformation.selfDescription.value
    );
    formData.append(
      "user[personal_information_attributes][first_name]",
      personalInformation.firstName.value
    );
    formData.append(
      "user[personal_information_attributes][middle_name]",
      personalInformation.middleName?.value || ""
    );
    formData.append(
      "user[personal_information_attributes][last_name]",
      personalInformation.lastName.value
    );
    formData.append(
      "user[personal_information_attributes][social_name]",
      personalInformation.socialName.value
    );
    formData.append(
      "user[personal_information_attributes][cellphone]",
      personalInformation.cellphone.value
    );
    formData.append(
      "user[personal_information_attributes][landline]",
      personalInformation.landline.value
    );
    formData.append(
      "user[personal_information_attributes][last_email]",
      personalInformation.lastEmail.value
    );
    formData.append(
      "user[personal_information_attributes][drivers_license]",
      personalInformation.driversLicense.value
    );
    formData.append(
      "user[personal_information_attributes][gender]",
      personalInformation.gender.value
    );
    formData.append(
      "user[personal_information_attributes][identify_lgtbi]",
      personalInformation.identify_lgtbi.value
    );
    formData.append(
      "user[personal_information_attributes][is_otd]",
      personalInformation.is_otd.value
    );
    formData.append(
      "user[personal_information_attributes][other_gender]",
      personalInformation.otherGender.value
    );
    formData.append(
      "user[personal_information_attributes][birthdate]",
      personalInformation.birthdate.value
    );
    formData.append(
      "user[personal_information_attributes][territory_commune_id]",
      personalInformation.commune.value
    );
    formData.append(
      "user[personal_information_attributes][address]",
      personalInformation.address.value
    );
    formData.append(
      "user[personal_information_attributes][territory_nationality_id]",
      personalInformation.nationality.value
    );
    formData.append(
      "user[personal_information_attributes][education_level]",
      personalInformation.educationLevel.value
    );
    if (disabilityInformation.id.value) {
      formData.append(
        "user[disability_information_attributes][id]",
        disabilityInformation.id.value
      );
    }
    if (disabilityInformation.hasDisability.value !== null) {
      formData.append(
        "user[disability_information_attributes][has_disability]",
        disabilityInformation.hasDisability.value
      );
    }
    if (disabilityInformation.hasDisabilityCredential.value !== null) {
      formData.append(
        "user[disability_information_attributes][has_disability_credential]",
        disabilityInformation.hasDisabilityCredential.value
      );
    }
    if (disabilityInformation.hasInvalidityPension.value !== null) {
      formData.append(
        "user[disability_information_attributes][has_invalidity_pension]",
        disabilityInformation.hasInvalidityPension.value
      );
    }
    if (contactInformation.id.value) {
      formData.append("user[contact_information_attributes][id]", contactInformation.id.value);
    }
    formData.append(
      "user[contact_information_attributes][relationship]",
      contactInformation.relationship.value
    );
    formData.append(
      "user[contact_information_attributes][contact_name]",
      contactInformation.contactName.value
    );
    formData.append(
      "user[contact_information_attributes][contact_email]",
      contactInformation.contactEmail.value
    );
    formData.append(
      "user[contact_information_attributes][contact_phone_number]",
      contactInformation.contactPhoneNumber.value
    );
    Object.entries(this.state.customAnswers).forEach(([questionId, value]) => {
      formData.append(`profile_custom_answers[${questionId}]`, value);
    });

    return formData;
  };

  setErrors = errors => {
    const { personalInformation, contactInformation } = this.state;
    personalInformation.selfDescription.errors = errors["personal_information.self_description"] || [];
    personalInformation.firstName.errors = errors["personal_information.first_name"] || [];
    personalInformation.firstName.errors = errors["personal_information.middle_name"] || [];
    personalInformation.lastName.errors = errors["personal_information.last_name"] || [];
    personalInformation.socialName.errors = errors["personal_information.social_name"] || [];
    personalInformation.birthdate.errors = errors["personal_information.birthdate"] || [];
    personalInformation.nationality.errors = errors["personal_information.nationality"] || [];
    personalInformation.gender.errors = errors["personal_information.gender"] || [];
    personalInformation.email.errors = errors.email || [];
    personalInformation.address.errors = errors["personal_information.address"] || [];
    personalInformation.educationLevel.errors = errors["personal_information.education_level"] || [];
    personalInformation.driversLicense.errors = errors["personal_information.drivers_license"] || [];

    personalInformation.commune.errors = errors["personal_information.territory_commune"] || [];
    personalInformation.region.errors = errors["personal_information.territory_commune"] || [];
    personalInformation.country.errors = errors["personal_information.territory_commune"] || [];
    personalInformation.cellphone.errors = errors["personal_information.cellphone"] || [];
    personalInformation.avatar.errors = errors.avatar || [];
    personalInformation.documentId.errors = errors.identification_document_number || [];

    contactInformation.relationship.errors = errors["contact_information.relationship"] || [];
    contactInformation.contactName.errors = errors["contact_information.contact_name"] || [];
    contactInformation.contactPhoneNumber.errors = errors["contact_information.contact_phone_number"] || [];
    contactInformation.contactEmail.errors = errors["contact_information.contact_email"] || []

    if (errors.profile_custom_answers) {
      this.setState(prevState => ({
        ...prevState,
        profileCustomQuestions: prevState.profileCustomQuestions.map(q => ({
          ...q,
          errors: (errors.profile_custom_answers[q.id] || [])
        }))
      }));
    } else {
      this.setState(prevState => ({
        ...prevState,
        profileCustomQuestions: prevState.profileCustomQuestions.map(q => ({
          ...q,
          errors: []
        }))
      }));
    }

    this.setState({
      ...this.state,
      personalInformation,
      contactInformation
    });
  };


  handleSubmit = e => {
    e.preventDefault();
    this.setState({ wasSubmitted: true }, () => {
      let data = this.serializeData();
      savePersonaInformation(data, response => {
        if (response.status === 200) {
          this.showNotification("Guardado", "Guardado exitoso", "success");
          this.props.toggleTab("academicinfo");
          this.setState({ wasSubmitted: false });
        } else if (response.status === 422) {
          console.log('ERRORES RECIBIDOS', response.data);
          this.setErrors(response.data);
          this.showNotification(
            "Guardado",
            "Ocurrió un error, revisa el formulario",
            "danger"
          );
        }
      });
    });
  };

  render() {
    const { personalInformation, disabilityInformation, contactInformation, profileCustomQuestions, customAnswers } = this.state;
    const image = personalInformation.avatar.value
     ? personalInformation.avatar.value
     : "/assets/User_Avatar_2.png";

    return (
      <div>
        <Form>
          <Row>
            <Col lg="12" md="12">
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="firstName" className="input_required">
                      Primer Nombre
                    </Label>
                    <FieldWrapper errors={personalInformation.firstName.errors}>
                      <Input
                        id="firstName"
                        name="firstName"
                        placeholder="Primer Nombre"
                        type="text"
                        onChange={this.handleChangePersonalInformation}
                        value={personalInformation.firstName.value}
                        autoFocus
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="middleName">
                      Segundo Nombre
                    </Label>
                    <FieldWrapper errors={personalInformation.middleName?.errors || []}>
                      <Input
                        id="middleName"
                        name="middleName"
                        placeholder="Segundo Nombre"
                        type="text"
                        onChange={this.handleChangePersonalInformation}
                        value={personalInformation.middleName?.value || ""}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="lastName" className="input_required">
                      Apellidos
                    </Label>
                    <FieldWrapper errors={personalInformation.lastName.errors}>
                      <Input
                        id="lastName"
                        name="lastName"
                        placeholder="Apellidos"
                        type="text"
                        onChange={this.handleChangePersonalInformation}
                        value={personalInformation.lastName.value}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">

                  <FormGroup>
                    <Label htmlFor="documentId" className="input_required">
                      RUT
                    </Label>
                    <FieldWrapper errors={personalInformation.documentId.errors}>
                      <Input
                        id="documentId"
                        name="documentId"
                        placeholder="RUT"
                        type="text"
                        onChange={this.handleChangePersonalInformation}
                        maxLength={12}
                        value={format(personalInformation.documentId.value)}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="birthdate" className="input_required">Fecha de Nacimiento</Label>
                    <FieldWrapper errors={personalInformation.birthdate.errors}>
                    <Input
                      id="birthdate"
                      name="birthdate"
                      placeholder="Fecha de Nacimiento"
                      type="date"
                      onChange={this.handleChangePersonalInformation}
                      value={personalInformation.birthdate.value || ""}
                    />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="nationality" className="input_required">Nacionalidad</Label>
                    <FieldWrapper errors={personalInformation.nationality.errors}>
                      <NationalitiesSelect
                        handleChange={this.handleChangePersonalInformation}
                        value={personalInformation.nationality}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup tag="fieldset">
                    <legend className="col-form-Label pt-0 h6 input_required" id="genderLabel">
                      Género
                    </legend>
                    <FieldWrapper errors={personalInformation.gender.errors}>
                    <FormGroup role="radiogroup" aria-labelledby="genderLabel">
                      <FormGroup check inline>
                        <Label check htmlFor="genderCheck1">
                          <Input
                            id="genderCheck1"
                            name="gender"
                            type="radio"
                            value="female"
                            checked={personalInformation.gender.value === "female"}
                            onChange={e => {
                              this.handleChangePersonalInformation(e);
                            }}
                          />
                          Femenino
                        </Label>
                      </FormGroup>
                      <FormGroup check inline>
                        <Label check htmlFor="genderCheck2">
                          <Input
                            id="genderCheck2"
                            name="gender"
                            type="radio"
                            value="male"
                            checked={personalInformation.gender.value === "male"}
                            onChange={e => {
                              this.handleChangePersonalInformation(e);
                            }}
                          />
                          Masculino
                        </Label>
                      </FormGroup>
                      <FormGroup check inline>
                        <Label check htmlFor="genderCheck3">
                          <Input
                            id="genderCheck3"
                            name="gender"
                            type="radio"
                            value="prefer_not_say"
                            checked={personalInformation.gender.value === "prefer_not_say"}
                            onChange={e => {
                              this.handleChangePersonalInformation(e);
                            }}
                          />
                          Prefiero no decirlo
                        </Label>
                      </FormGroup>
                    </FormGroup>
                    </FieldWrapper>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md="12">
              <h3 className="h6 font-weight-bold">
                <i className="far fa-address-book me-2"></i>
                Datos de Contacto
              </h3>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="email" className="input_required">Email</Label>
                <FieldWrapper errors={personalInformation.email.errors}>
                <Input
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="text"
                  onChange={this.handleChangePersonalInformation}
                  value={personalInformation.email.value}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="lastEmail">Email adicional</Label>
                <Input
                  id="lastEmail"
                  name="lastEmail"
                  placeholder="Email adicional"
                  type="text"
                  onChange={this.handleChangePersonalInformation}
                  value={personalInformation.lastEmail.value}
                />
              </FormGroup>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="cellphone" className="input_required">
                  Teléfono de Contacto
                </Label>
                <FieldWrapper errors={personalInformation.cellphone.errors}>
                  <Input
                    id="cellphone"
                    name="cellphone"
                    placeholder=" Teléfono de Contacto"
                    type="text"
                    onChange={this.handleChangePersonalInformation}
                    value={personalInformation.cellphone.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md="12">
              <h3 className="h6 font-weight-bold">
                <i className="fas fa-map-marker-alt me-2"></i>
                Domicilio Actual
              </h3>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label htmlFor="address" className="input_required">Dirección</Label>
                <FieldWrapper errors={personalInformation.address.errors}>
                <Input
                  id="address"
                  name="address"
                  placeholder="Dirección"
                  type="text"
                  onChange={this.handleChangePersonalInformation}
                  value={personalInformation.address.value}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <TerritoryNestedSelects
              handleChange={this.handleChangePersonalInformation}
              countryValue={personalInformation.country}
              regionValue={personalInformation.region}
              communeValue={personalInformation.commune}
            />
          </Row>
          <hr />
          <Row>
            <Col md="4">
              <FormGroup>
                <Label htmlFor="educationLevel" className="input_required">Nivel Educacional</Label>
                <FieldWrapper errors={personalInformation.educationLevel.errors}>
                <EducationLevelsSelect
                  handleChange={this.handleChangePersonalInformation}
                  value={personalInformation.educationLevel}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label htmlFor="driversLicence" className="input_required">Licencia de Conducir</Label>
                <FieldWrapper errors={personalInformation.driversLicense.errors}>
                <DriversLicensesSelect
                  handleChange={this.handleChangePersonalInformation}
                  value={personalInformation.driversLicense}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <ProfileCustomQuestions
            questions={profileCustomQuestions}
            answers={customAnswers}
            onChange={this.handleCustomAnswerChange}
            wasSubmitted={this.state.wasSubmitted}
          />
          <Card className="bg-light mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h3 className="h6 font-weight-bold mb-3">
                    <i className="fas fa-user-friends me-2"></i>
                    Datos de Contacto Alternativo
                    <small className="mt-1 form-text ms-2">
                      Un Familiar o amigo(a) con el que puedan contactarse para ubicarte
                    </small>
                  </h3>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label htmlFor="relationship" >Parentesco</Label>
                    <FieldWrapper errors={contactInformation.relationship.errors}>
                      <RelationshipContactSelect
                        handleChange={this.handleChangeContactInformation}
                        value={contactInformation.relationship}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label htmlFor="contactName" >Nombre</Label>
                    <FieldWrapper errors={contactInformation.contactName.errors}>
                    <Input
                      id="contactName"
                      name="contactName"
                      placeholder="Nombre"
                      type="text"
                      onChange={this.handleChangeContactInformation}
                      value={contactInformation.contactName.value}
                    />
                  </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label htmlFor="contactPhoneNumber" >Teléfono</Label>
                    <FieldWrapper errors={contactInformation.contactPhoneNumber.errors}>
                    <Input
                      id="contactPhoneNumber"
                      name="contactPhoneNumber"
                      placeholder="Teléfono"
                      type="text"
                      onChange={this.handleChangeContactInformation}
                      value={contactInformation.contactPhoneNumber.value}
                    />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label htmlFor="contactEmail" >Email</Label>
                    <FieldWrapper errors={contactInformation.contactEmail.errors}>
                    <Input
                      id="contactEmail"
                      name="contactEmail"
                      placeholder="Email"
                      type="text"
                      onChange={this.handleChangeContactInformation}
                      value={contactInformation.contactEmail.value}
                    />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col md="12" className="text-end">
              <Button color="primary" className="my-4" onClick={this.handleSubmit}>
                Guardar
                <i className="fas fa-arrow-right ms-2"></i>
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default PersonalInformationForm;
